export const validateMultiStoneFields = (filters) => {
  let errs = []

  if (filters.multi_stone_quality === null) {
    errs = errs.concat(['Multi-Stone Quality'])
  }

  if (filters.small_diamond_id === null) {
    errs = errs.concat(['Multi-Stone Size'])
  }

  if (filters.multi_stone_setting === null) {
    errs = errs.concat(['Multi-Stone Type'])
  }

  if (filters.multi_stone_setting !== null && filters.multi_stone_shape && filters.multi_stone_shape.length === 0) {
    errs = errs.concat(['Multi-Stone Shape'])
  }

  return errs
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/multi-stone-fields/index.js